import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import apiRequest from "apiRequest";

const VehicleCard = ({ images, label, title, description, vehicleDataSubCategory,action }) => {
  // console.log("VehicleCard vehicle:", );
  return (
    <Card sx={{ height: "100%" }}>
      {images?.length > 0 && (
        <Carousel
          showThumbs={false}
          autoPlay
          infiniteLoop
          showStatus={false}
          emulateTouch
        >
          {images.map((src, idx) => (
            <div key={idx}>
              <img
                src={src}
                alt={`vehicle-slide-${idx}`}
                style={{ width: "100%", height: 200, objectFit: "cover" }}
                onError={() => console.log("Image failed to load:", src)}
              />
            </div>
          ))}
        </Carousel>
      )}
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {description}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
        {/* SubCategories */}
      {/* <div >
              <img
                src={images[3]}
                alt={`vehicle-slide-${images[3]}`}
                style={{ width: "100%", height: 200, objectFit: "cover" }}
                onError={() => console.log("Image failed to load:", images[3])}
              />
            </div> */}
            <Typography variant="body2" sx={{ mt: 1 }}>
             Service Name : {vehicleDataSubCategory}
            </Typography>
        </Typography>
       
        {/* <Button
          sx={{ mt: 2 }}
          variant="contained"
          color={action.color || "primary"}
          href={action.route}
        >
          {action.label}
        </Button> */}
      </CardContent>
    </Card>
  );
};

export default VehicleCard;
